/*global jQuery*/

jQuery(document).ready(function ($) {
    "use strict";

    function getScrollOffset() {
        var navbar = $(".navbar"),
        height = 0;

        if (navbar.length > 0) {
            height = height + navbar.height();
        }

        return -height;

    }

  function scrollTo(trigger, target, offset, speed) {
    $(trigger).click(function (e) {
            if (offset === 0) {
                offset = getScrollOffset();
            }

            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(target).offset().top + offset
            }, speed);
      });
  }

    //data-api
    $("[data-scrollto]").each(function (index, elem) {
        var trigger = elem,
            target = $(elem).data("scrollto"),
            offset = $(elem).data("scrollto-offset") || -110,
            speed = $(elem).data("scrollto-speed") || 1000;

        scrollTo(trigger, target, offset, speed);
    });
});
